//https://www.canva.com/colors/color-wheel/

const Themes = function () {
    let themesColor = {
        light: {
            brandPrimary: "#0078D4",
            brandSecondary: "#005A9E",
            textPrimary: "#323130",
            colorTheme1: "#ffffff",
            colorTheme2: "#e1dfdd",
            colorTheme3: "#f3f2f1"
        },
        dark: {
            brandPrimary: "#0078D4",
            brandSecondary: "#005A9E",
            textPrimary: "#f3f2f1",
            colorTheme1: "#201f1e",
            colorTheme2: "#323130",
            colorTheme3: "#3b3a39"
        },
        custom: {
            // Define custom theme properties
        },
        // Add more themes as needed
    }

    this.loadAppTheme = function () {
        Office.onReady((info) => {
            Office.addin.onVisibilityModeChanged(function (args) {
                if (args.visibilityMode == "Taskpane") {
                    this.getAndSetTheme(false);
                }
            });
            this.getAndSetTheme(true);
        });
    }
    this.getAndSetTheme = function (isReset) {
        if (Office.context.platform === Office.PlatformType.OfficeOnline) {

            const fabricElement = document.querySelector('.ms-Fabric');
            if (fabricElement && fabricElement.classList.contains('ms-Fabric--isDark')) {
                this.applyOfficeTheme(true, isReset);
                console.log('Excel Web Theme: dark');
            } else {
                this.applyOfficeTheme(false, isReset);
                console.log('Excel Web Theme: light (ms-Fabric--isDark not found or ms-Fabric missing)');
            }

        }
        else if (Office.context.platform === Office.PlatformType.Android) {
            // to support android device theming need to write code here 
        }
        else {
            this.applyOfficeTheme(Office.context.officeTheme.isDarkTheme, isReset);
        }
    }

    // isReset is true when some on apply hard refresh panel page
    this.applyOfficeTheme = function (isDarkMode, isReset) {
        // return true;
        let themeMode = isDarkMode ? "dark" : "light";
        let lastThemeMode = sessionStorage.getItem("eeThemeMode");
        if (isReset || !lastThemeMode || themeMode != lastThemeMode) {
            let theme = themesColor[themeMode];
            document.documentElement.style.setProperty('--ee-brandPrimary', theme.brandPrimary);
            document.documentElement.style.setProperty('--ee-brandSecondary', theme.brandSecondary);
            document.documentElement.style.setProperty('--ee-textPrimary', theme.textPrimary);
            // document.documentElement.style.setProperty('--ee-textSecondary', theme.textSecondary);
            // document.documentElement.style.setProperty('--ee-textBrand', theme.textBrand);

            document.documentElement.style.setProperty('--ee-colorTheme1', theme.colorTheme1);
            document.documentElement.style.setProperty('--ee-colorTheme2', theme.colorTheme2);
            document.documentElement.style.setProperty('--ee-colorTheme3', theme.colorTheme3);

            // document.documentElement.style.setProperty('--ee-colorGreen', theme.colorGreen);
            // document.documentElement.style.setProperty('--ee-colorRed', theme.colorRed);
            // document.documentElement.style.setProperty('--ee-colorWhite-rgb', hexToRgb(theme.colorWhite));

            sessionStorage.setItem("eeThemeMode", themeMode);
        }
    }

    function hexToRgb(hex) {
        // Remove the '#' character (if present)
        hex = hex.replace('#', '');

        // Convert hex to RGB components
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // Return RGB components as an object
        return r + ", " + g + ", " + b;
    }
}

export default Themes;